import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            Shop Categories
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">
            Explore Our Product Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Browse through our curated collections and discover premium products across every category. Each click takes you directly to the best deals on Superbuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col items-center rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer p-4 md:p-5"
            >
              <div className="w-full aspect-square rounded-lg overflow-hidden bg-background-200/50 mb-3 md:mb-4">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category shopping on Superbuy Spreadsheet`}
                  title={`${cat.name} - Superbuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <span className="font-heading text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <i className="ri-arrow-right-up-line absolute top-5 right-5 text-xs text-foreground-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}